<template>
  <div class="ihc-root">
    <div class="ihc-row1">{{ item ? item.indicatorName : '' }}</div>
    <div class="ihc-row2">
      <span class="ihc-side">{{ item ? ParseNumber(item.lowerLimit) : '' }}</span>
      <span class="ihc-center">{{ item ? ParseNumber(item.onlineValue) : '' }}</span>
      <span class="ihc-side">{{ item ? ParseNumber(item.upperLimit) : '' }}</span>
    </div>
    <div class="ihc-row3">
      <span>{{ item ? ParseNumber(item.workshiftAIndicatorReability) : '' }}</span>
      <span>{{ item ? ParseNumber(item.workshiftBIndicatorReability) : '' }}</span>
      <span>{{ item ? ParseNumber(item.workshiftCIndicatorReability) : '' }}</span>
      <span>%</span>
    </div>
  </div>
</template>

<script>
import { FiltersMixin } from '../mixins/filtersMixin';

export default {
  name: 'IndicatorHeaderCard',
  props: ['item'],
  mixins: [FiltersMixin],
};
</script>

<style scoped>
.ihc-root {
  width: 100%;
  display: grid;
  grid-template-rows: auto 1fr auto;
  font-size: 1.3em;
  color: rgb(255, 255, 255);
}

.ihc-row1 {
  font-size: 0.6em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 5px;
  font-weight: 500;
}

.ihc-row2 {
  display: grid;
  grid-template-columns: auto auto auto;
  text-align: center;
  align-items: center;
}

.ihc-side {
  font-size: 0.6em;
  text-align: center;
  font-weight: 500;
}

.ihc-center {
  letter-spacing: 0.8px;
  font-weight: 500;
  text-align: center;
}

.ihc-row3 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  font-size: 0.6em;
  font-weight: 400;
  text-align: center;
}
</style>
